module.exports = __webpack_public_path__ + "img/crypto.32ac142c.svg";